module.exports = __webpack_public_path__ + "fonts/segoeuiz.cb53f806.ttf";